import React from "react";

export const AsignationShowQuiz = ({
	evaluationResult,
	evaluationPerfect,
	closeModal3,
}) => {
	if (!evaluationResult || evaluationResult.length === 0) {
		return <h3>No hay evaluaciones para mostrar</h3>;
	}

	return (
		<div>
			{evaluationResult.map((evalData, idx) => {
				if (!evalData) {
					return (
						<div key={idx} style={{ marginBottom: "1rem", color: "red" }}>
							⚠️ Datos de intento inválidos
						</div>
					);
				}

				const {
					nameEvaluation = "—",
					student = "—",
					date = "—",
					questions = [],
					answers = [],
					califications = [],
				} = evalData;

				const totalPreguntas = Array.isArray(questions) ? questions.length : 0;
				const correctas = Array.isArray(califications)
					? califications.filter((c) => c === 1).length
					: 0;
				const porcentaje =
					totalPreguntas > 0
						? ((correctas / totalPreguntas) * 100).toFixed(2)
						: "0.00";

				return (
					<div
						key={idx}
						style={{
							marginBottom: "2rem",
							padding: "1rem",
							border: "1px solid #ddd",
							borderRadius: 8,
						}}
					>
						<h3>
							<strong>Intento {idx + 1}</strong> — {nameEvaluation} para{" "}
							{student}
						</h3>
						<p>Fecha: {date}</p>

						{totalPreguntas > 0 ? (
							<ol>
								{questions.map((q, i) => {
									const respuestaEstudiante = answers[i] ?? "—";
									const esCorrecta = califications[i] === 1;

									// Buscar la respuesta correcta según la pregunta
									const correctAnswerObj = evaluationPerfect.find(
										(p) => p.question === q
									);
									const respuestaCorrecta = correctAnswerObj
										? correctAnswerObj.answer
										: "—";

									return (
										<li key={i} style={{ marginBottom: "1rem" }}>
											<p>
												<strong>Pregunta {i + 1}:</strong> {q}
											</p>
											<p
												style={{
													color: esCorrecta ? "green" : "red",
													fontWeight: "bold",
												}}
											>
												Respuesta estudiante: {respuestaEstudiante} (
												{esCorrecta ? "✔️ Correcta" : "❌ Incorrecta"})
											</p>
											{!esCorrecta && (
												<p style={{ color: "green" }}>
													Respuesta correcta: {respuestaCorrecta}
												</p>
											)}
										</li>
									);
								})}
							</ol>
						) : (
							<p style={{ color: "orange" }}>
								⚠️ No hay preguntas en este intento
							</p>
						)}

						<h4>
							Calificación total:{" "}
							<span
								style={{
									color: correctas === totalPreguntas ? "green" : "red",
								}}
							>
								({porcentaje}%)
							</span>
						</h4>
					</div>
				);
			})}

			<div style={{ textAlign: "center", marginTop: "2rem" }}>
				<input
					type="reset"
					value="Cerrar"
					onClick={closeModal3}
					className="btn-close-reg-asign"
				/>
			</div>
			<br></br>
			<br></br>
			<br></br>
		</div>
	);
};
